export default [
  {
    name: 'Categorias',
    path: 'categorias',
    component: () => import('@/views/categorias/Index.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [{ name: 'Administração', path: '/administracao' }, { name: 'Categorias' }]
    }
  },
  {
    name: 'Categorias Editar',
    path: 'categorias/edit/:id',
    component: () => import('@/views/categorias/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Categorias', path: '/administracao/categorias' },
        { name: 'Adicionar' }
      ]
    }
  },
  {
    name: 'Categorias Adicionar',
    path: 'categorias/edit',
    component: () => import('@/views/categorias/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Categorias', path: '/administracao/categorias' },
        { name: 'Adicionar' }
      ]
    }
  }
];
